<template>
  <v-container fluid>
    <h2 class="text-h4 mb-3">{{$t('allProjects.title')}}</h2>
    <v-alert v-if="!isHelpdesk" type="error">Not authorized</v-alert>
    <template v-else-if="dlist && clist">
      <v-card>
        <v-card-text>
          <v-text-field
            :placeholder="$t('common.search')"
            v-model="search"
            prepend-icon="$search"
            clearable
          />
        </v-card-text>
        <v-data-table
            :loading="saving"
          sort-by="alert"
          sort-desc
          show-expand
          :items-per-page="-1"
          :expanded="expanded"
           xgroup-by="cname"
           item-key="id"
          :headers="headers"
          :items="tableData"
          :search="search"
        >
          <template v-slot:[`item.name`]="{ item }">
            <router-link v-if="item.link" :to="item.link">{{ item.name }}</router-link>
          </template>
          <template v-slot:[`item.email`]="{ item }">
            <a :href="`mailto:${item.email}`">{{ item.email }}</a>
          </template>
          <template v-slot:[`item.cname`]="{ item }">
            <router-link :to="item.clink">{{ item.cname }}</router-link>
          </template>
          <template v-slot:[`item.alert`]="{ item }">
            <v-icon color="error" v-if="item.alert == 2">$warn</v-icon>
            <v-icon v-else-if="item.alert" color="warning">$ok</v-icon>
            <v-icon v-else color="success">$ok</v-icon>
          </template>
         <template v-slot:[`item.to`]="{ item }">
            {{ formatDate(item.to, true) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <action-button
              v-if="item.active && item.active.indexOf('BLOCKED') != 0"
              tooltip="Block"
              icon="$blocked"
              @click="block(item.id)"
            />
            <action-button
              v-if="item.active && item.active.indexOf('BLOCKED') == 0"
              tooltip="Unblock"
              icon="$refresh"
              @click="block(item.id, 'ACTIVE')"
            />
            <action-button
              v-if="item.active && item.active == 'PURGED'"
              tooltip="Delete project"
              icon="$remove"
              @click="prepareRemove('domains',item)"
            />
            <!-- Only company with no projects-->
            <action-button
              v-if="!item.active"
              tooltip="Delete company"
              icon="$remove"
              @click="prepareRemove('companies', item)"
            />
            <action-button tooltip="Adjust period/visitors" @click="edit(item)" icon="$edit" />
          </template>
          <template #expanded-item="{ item }">
              <td :colspan="headers.length">
                <v-row justify="space-around">
                <div>
                    <v-subheader>Basic info</v-subheader>
                <v-list subheader>
              <v-list-item :href="`mailto:${item.email}`" target="_blank">
                <v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-subtitle>E-mail</v-list-item-subtitle>
                  <v-list-item-title>{{item.email}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :href="`tel:${item.phone}`" target="_blank">
                <v-list-item-icon><v-icon>$phone</v-icon></v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-subtitle>Phone</v-list-item-subtitle>
                  <v-list-item-title>{{item.phone}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
              <v-list-item-icon><v-icon>$platform</v-icon></v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-subtitle>Platform</v-list-item-subtitle>
                  <v-list-item-title>{{formatPlatform(item.platform)}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
              <v-list-item-icon><v-icon>$json</v-icon></v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-subtitle>Project ID</v-list-item-subtitle>
                  <v-list-item-title><code>{{item.id}}</code></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            </div>
                <div>
                    <v-subheader>Subscription</v-subheader>
                <v-list subheader>
              <v-list-item>
                <v-list-item-icon><v-icon>$billing</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Billing type</v-list-item-subtitle>
                  <v-list-item-title>{{ item.stripe ? 'Stripe' : item.manual ? 'Manual invoicing' : 'Trial' }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$calendarFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>From</v-list-item-subtitle>
                  <v-list-item-title>{{ formatDate(item.from, true) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$calendarTo</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>To</v-list-item-subtitle>
                  <v-list-item-title>{{ formatDate(item.to, true) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$visitors</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Visitors</v-list-item-subtitle>
                  <v-list-item-title>{{item.visits}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$segmentFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Limit</v-list-item-subtitle>
                  <v-list-item-title>{{ item.limit }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            </div>
            <div>
              <v-subheader>Capabilities</v-subheader>
              <v-list subheader>
                    <v-list-item v-for="(v,c) in item.capabilities" :key="c">
                        <v-list-item-icon>
                            <tooltip-icon 
                            :icon="(v ? '$ok' : '$nok') + (requiredCapabilities[c] ? '' : '_outline')"
                            :tooltip="(requiredCapabilities[c] ? $t('form.required') : $t('form.optional'))+', ' + (v ? $t('overview.capabilities.working') : $t('overview.capabilities.notWorking'))"
                            :color="v ? 'success' : 'error'" />
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ formatCapability(c) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
            <div>
                    <v-subheader>Operation</v-subheader>
                <v-list subheader>
              <v-list-item
                    id="pfid1618853049" 
                    >
                        <v-list-item-icon>
                            <v-icon>$recommendationsUpdate</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('overview.status.recommendations')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatDate(item.recommendationsUpdated) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                    id="pfid1618853057" >
                        <v-list-item-icon>
                            <v-icon>$productsUpdate</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('overview.status.products')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatDate(item.productsUpdated) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon>$productFeed</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-subtitle>{{$t('domains.productCount')}}</v-list-item-subtitle>
                          <v-list-item-title>{{
                            formatNumber(item.productCount,0)
                          }}</v-list-item-title>
                          </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list-item>
                    <v-list-item-icon><v-icon>$sales</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{$t('domains.sales', { date: formatDate(item.from, true)})}}</v-list-item-subtitle>
                      <v-list-item-title>{{ formatNumber(item.sales,0) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-icon><v-icon>$sentTotal</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{$t('domains.emailsSent', { date: formatDate(item.from, true)})}}</v-list-item-subtitle>
                      <v-list-item-title>{{ formatNumber(item.emailsSent,0) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="showHistory(item)">
                    <v-list-item-icon><v-icon>$history</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ $t('domains.showHistory') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </div>

            <div>
                    <v-subheader>Mailing</v-subheader>
                <v-list subheader>
              <v-list-item>
                  <v-list-item-icon>
                            <v-icon>$importCustomers</v-icon>
                        </v-list-item-icon>
                <v-list-item-content>
                    
                  <v-list-item-subtitle>Contacts imported</v-list-item-subtitle>
                  <v-list-item-title>{{ formatBoolean(item.contactsImported)}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                  <v-list-item-icon>
                            <v-icon>$importOrders</v-icon>
                        </v-list-item-icon>
                <v-list-item-content>
                    
                  <v-list-item-subtitle>Orders imported</v-list-item-subtitle>
                  <v-list-item-title>{{ formatBoolean(item.ordersImported)}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- --------------------- -->
              
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>$emailRecipients</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('domains.emailCount')}}</v-list-item-subtitle>
                  <v-list-item-title>{{ formatNumber(item.totalEmailRecipients) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              
              <v-list-item>
                  <v-list-item-icon>
                            <v-icon>$mailing</v-icon>
                        </v-list-item-icon>
                <v-list-item-content>
                    
                  <v-list-item-subtitle>Bounces</v-list-item-subtitle>
                  <v-list-item-title>{{item.bounces || 0}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <action-button @click="resetCounter(item.id, 'bounces')" icon="$clear" tooltip="Reset counter" />
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                  <v-list-item-icon>
                            <v-icon>$mailing</v-icon>
                        </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Complaints</v-list-item-subtitle>
                  <v-list-item-title>{{item.complaints || 0}}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <action-button @click="resetCounter(item.id, 'complaints')" icon="$clear" tooltip="Reset counter" />
                </v-list-item-action>
              </v-list-item>
            </v-list>
            </div>
            
            </v-row>
            <v-row v-if="item.showHistory">
              <v-col cols="12">
              <v-card-title>{{ $t('billing.history.title') }} &ndash; {{ item.cname }}</v-card-title>
              </v-col>
              <v-col cols="12">
              <v-data-table :headers="historyHeaders" :items="item.history" v-if="item.history">
              <template #item.subscription.from="{ item }">
                {{ formatDate(item.subscription.from) }}
              </template>
              <template #item.subscription.to="{ item }">
                {{ formatDate(item.subscription.to) }}
              </template>
            
              </v-data-table>
              <v-skeleton-loader type="table" v-else />
            </v-col>
            </v-row>
              </td>
              
          </template>
          <template v-slot:[`group.header`]="{ toggle, isOpen, headers, group }">
              <td :colspan="headers.length">
                <v-row no-gutters align="center">
                <action-button class="ma-0" @click="toggle" :icon="isOpen ? '$minus' : '$plus'" :tooltip="isOpen ? $t('webboxes.collapse') : $t('webboxes.expand')" />
                 <span>Company name</span> : {{ group }}
                 <v-spacer />
                 <action-button tooltip="Adjust visitor limit" icon="$visitors" />
                 <action-button tooltip="Adjust period" icon="$calendarTo" />
                </v-row>
              </td>
              
          </template>
        </v-data-table>
      </v-card>
    </template>
    <v-skeleton-loader v-else type="table" />
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title>{{editedItem.name}} &ndash; Edit subscription</v-card-title>
            <v-card-text>
                <v-text-field prepend-icon="$visitors" label="Visitor limit" v-model.number="editedItem.limit" type="number"/>
                <label class="v-label"><v-icon left>$calendarTo</v-icon> End of period</label>
                <!-- cant change date when stripe is enabled -->
                <v-date-picker :disabled="editedItem.stripe" class="mt-1" :first-day-of-week="1" :locale="locale" full-width v-model="editedItem.to"></v-date-picker>
                <v-switch prepend-icon="$active" label="Enable manual invoicing" :disabled="editedItem.stripe" v-model="editedItem.manual"/>
                <v-switch prepend-icon="$active" label="Activate company" :disabled="editedItem.active == 'ACTIVE'" v-model="editedItem.enable"/>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" :loading="saving" text @click="update"><v-icon left>$ok</v-icon>Confirm</v-btn>
                <v-btn text @click="dialog = false"><v-icon left>$close</v-icon>Close</v-btn>
                <v-btn text @click="editedItem.limit += editedItem.visits"><v-icon left>$refresh</v-icon>Recalculate limit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <confirm-dialog button-caption="Remove" v-model="removeConfirm" :saving="saving" @confirm="remove()">
      Are you sure to remove company/project {{ removeName }}?
    </confirm-dialog>
  </v-container>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Formatters from "@/mixins/formatters";
import DomainStatus from "@/mixins/domain-status";
import Capabilities from "@/mixins/capabilities";

export default {
  name: "Helpdesk",
  mixins: [Formatters, DomainStatus, Capabilities],
  data() {
    return {
      table: false,
      search: null,
      expanded: [],
      dialog: false,
      saving: false,
      editedItem: {
          id: null,
          name: null,
          from: null,
          to: null,
          limit: null,
          active: null,
          enable: null,
          visits: null,
          stripe: null,
          manual: null
      },
      headers: [
        { text: "Company name", value: "cname" },
        { text: "Project name", value: "name" },
        //{ text: "Contact", value: "email" },
        { text: "Status", value: "status" },
        { text: "Alert", value: "alert" },
        { text: "Problem", value: "problem" },
        { text: "Detail", value: 'data-table-expand' },
        
        { text: "Visitor limit (Company)", value: "limit" },
        { text: 'Remaining visits', value: 'remaining'},
        //{ text: "Visits (Company)", value: "visits" },
        //{ text: "Period start", value: "start" },
        { text: "Period end", value: "to" },
        /*
        { text: "Sales", value: "sales" },
        { text: "Bounces", value: "bounces" },
        { text: "Complaints", value: "complaints" },
        */
        { text: "Actions", value: "actions", align: 'end' },
      ],
      historyHeaders: [
                { text: this.$t('common.intervals.from'), value: 'subscription.from' },
                { text: this.$t('common.intervals.to'), value: 'subscription.to'},
                { text: this.$t('billing.visitorLimit'), value: 'subscription.monthlyUserLimit'},
                { text: this.$t('billing.consumedVisits'), value: 'stats.monthlyUsers'},
                { text: this.$t('billing.sales'), value: 'stats.dreamroiSales'},
                { text: this.$t('billing.emails'), value: 'stats.emailsSent'},
            ],
      removeConfirm: false,
      removeType: null,
      removeLoading: false,
      removeId: null,
      removeName: null
    };
  },
  computed: {
    tableData() {
      if (!(this.dlist && this.clist)) {
        return [];
      }
      let records = [];
      this.clist.forEach(c => {
        console.debug('company', c);
        let domains = this.dlist.filter(d => d.companyID == c.id);
        console.debug('domains', domains);
        
        if(domains.length == 0) {
          records.push(this.getRow(c));
        } else {
          domains.forEach(d => records.push(this.getRow(c, d)));
        }
        
      });
      return records;
    },
    ...mapState("helpdesk", ["clist", "dlist"]),
    ...mapState("ui", ["locale"]),
    ...mapGetters("auth", ["isHelpdesk"]),
  },
  methods: {
      getRow(c, d) {
        if(!c) {
            console.debug('domain without company', d);
            return;
        }
        if(!d) {
          d = {};
        }
        let alert = 0;
        let problem = null;
        // copied from amplify\backend\function\dreamroisessnshandler\src\index.js
        let climit = Math.floor(40 * Math.log10(d.totalEmailRecipients) * Math.log10(d.totalEmailRecipients)) //100 + d.totalEmailRecipients * 0.05;
        let blimit = climit * 10;

        if (d.bounces > blimit * 0.9) {
          alert = 2;
          problem = `Too much bounces – limit is ${blimit}`;
        }
        else if (d.complaints > climit * 0.9) {
          alert = 2;
          problem = `Too much complaints – limit is ${climit}`;
        }

        if(c.active == "INCOMPLETE") {
          alert = 2;
          problem = "Company was not activated by Helpdesk";
        } else if (d.active == "BLOCKED_AUTOMATIC") {
          alert = 2;
        }
        else if (d.active == "OVER_LIMIT") {
          alert = 2;
        }
        else if (d.active == "PAYMENT_DUE") {
          alert = 2;
        }
        else if (d.active == "INCOMPLETE") {
          alert = 1;
        }
        else if (d.active == "CANCELLED") {
          alert = -1;
        }
        else if (d.active == "PURGED") {
          alert = -1;
        }
        else if (d.active == "BLOCKED_MANUAL") {
          alert = -1;
        } else if (
          c.stats?.monthlyUsers == 0 &&
          c.activeSubcription?.from >
            new Date(Date.now() - 1000 * 60 * 60 * 24 * 2).toISOString()
        ) {
          alert = 2;
          problem = "Tracking not working";
        }
        //console.debug(`${c.name} to ${c.activeSubscription?.to} min ${(new Date((Date.now() + (1000 * 60 * 60 * 24 * 14))).toISOString())} comp ${c.activeSubcription?.to < (new Date((Date.now() + (1000 * 60 * 60 * 24 * 14))).toISOString())}`);
        else if(d.productsUpdated < new Date(Date.now() - (1000 * 60 * 60 * 24)).toISOString()) {
            alert = 2;
            problem = "Products were not updated";
        }
        else if(d.recommendationsUpdated < new Date(Date.now() - (1000 * 60 * 60 * 24)).toISOString()) {
            alert = 2;
            problem = "Recommendations were not updated";
        }
        else if (
          c.activeSubscription?.to <
          new Date(Date.now() + 1000 * 60 * 60 * 24 * 7).toISOString()
        ) {
          alert = 2;
          problem = "End of period is approaching";
        }
        else if (
          c.stats?.monthlyUsers >
          c.activeSubcription?.monthlyUserLimit * 0.8
        ) {
          alert = 2;
          problem = "User limit is approaching";
        }
        

        return {
          id: d.id || c.id,
          name: d.id ? d.name || '[No project name]' : null,
          platform: d.platform, 
          cname: c.name || '[No company name]',
          cid: c.id,
          link: d.id ? {
            name: "domain-overview",
            params: { company: c.id, domain: d.id },
          } : null,
          clink: { name: "domains", params: { company: c.id } },
          email: c.email,
          phone: c.phone,
          active: d.active,
          cactive: c.active,
          status: this.getStatus(d || c).text,
          limit: c.activeSubscription?.monthlyUserLimit,
          visits: c.stats.monthlyUsers,
          remaining: c.activeSubscription ? c.activeSubscription.monthlyUserLimit - c.stats.monthlyUsers : null,
          from: c.activeSubscription?.from, // todo format in html, keep json here to allow correct sorting
          to: c.activeSubscription?.to,
          stripe: c.hasStripeSubscription,
          manual: c.hasManualInvoicing,
          sales: d.stats?.dreamroiSales,
          emailsSent: d.stats?.emailsSent,
          bounces: d.bounces,
          complaints: d.complaints,
          productsUpdated: d.productsUpdated,
          recommendationsUpdated: d.recommendationsUpdated,
          productCount: d?.stats?.products,
          capabilities: d?.capabilities ?? [],
          contactsImported: d?.contactsImported,
          ordersImported: d?.ordersImported,
          alert,
          problem,
          showHistory: false,
          history: null
        };
      },
      edit(item) {
          this.editedItem.name = item.cname;
          this.editedItem.id = item.cid;
          this.editedItem.from = item.from;
          this.editedItem.to = item.to?.substring(0,10);
          this.editedItem.limit = item.limit;
          this.editedItem.active = item.cactive;
          this.editedItem.enable = item.cactive != 'ACTIVE';
          this.editedItem.visits = item.visits;
          this.editedItem.stripe = item.stripe;
          this.editedItem.manual = item.manual;
          this.dialog = true;
      },
      update() {
            this.saving = true;
            let to = new Date(this.editedItem.to);
            //to.setDate(to.getDate() + 1);
            // update all domains - set active and set capabilities.allow, activate if needed
            Promise.all([(() => {
              let payload = { 
                id: this.editedItem.id,
                activeSubscription: {
                  from: this.editedItem.from || new Date(),
                  to,
                  monthlyUserLimit: this.editedItem.limit
                },
                // do not turn on manual invoicing for Stripe - it messes up stripe billed customers who had their limit increased by helpdesk
                hasManualInvoicing: this.editedItem.manual && !this.editedItem.stripe 
              };

              if(this.editedItem.enable) {
                payload.active = 'ACTIVE';
              }
              //returns promise
              return this.$store.dispatch('helpdesk/updateCompany', payload);
            })(),
            
            ...this.dlist.filter(d => d.companyID == this.editedItem.id).map(d => (() => {
              /*
              let cap = Object.assign({}, this.item.capabilities);
            cap.dkim = this.hasDkim;
            cap.spf = this.hasMailFrom;
            cap.linkDomain = this.hasTrackingDomain;
            // using method from entity-form mixin
            if(this.detectChange(cap, this.item.capabilities)) {
                let fields = { capabilities: cap };
                if(this.item.active == 'INACTIVE' && this.canActivate(cap)) {
                    fields.active = 'ACTIVE';
                }
                await this.$store.dispatch('domains/updateFields', { fields });
              */
              if(!this.editedItem.enable) {
                return Promise.resolve();
              }
              let payload = { 
                id: d.id
              };
              
              if(d.active == 'INCOMPLETE') {
                let cap = Object.assign({}, d.capabilities);
                cap.allow = true;
                payload.capabilities = cap;
                // returns promise
                if(this.canActivate(cap)) {
                  payload.active = 'ACTIVE';
                }
              } else {
                // the domain was already active - can switch to active without the check
                payload.active = 'ACTIVE';
              }
              
              
              // returns promise
              return this.$store.dispatch('helpdesk/updateDomain', payload);
            })())
            ]).then(() => this.$store.dispatch("helpdesk/list")).then(() => { this.saving = false; this.dialog= false; });
      },
      block(id, state) {
          this.saving = true;
          this.$store.dispatch('helpdesk/updateDomain', { 
              id,
              active: state || 'BLOCKED_MANUAL'
            }).then(() => this.$store.dispatch("helpdesk/list")).then(() => {this.saving = false});
      },
      /*
      removeDomain(id) {
        this.saving = true;
          this.$store.dispatch('domains/remove', { 
              id
            }).then(() => this.$store.dispatch("helpdesk/list")).then(() => {this.saving = false});
      },
      
      removeCompany(id) {
        this.saving = true;
          this.$store.dispatch('companies/remove', { 
              id
            }).then(() => this.$store.dispatch("helpdesk/list")).then(() => {this.saving = false});
      },
      */
      resetCounter(id, counter) {
          this.saving = true;
          this.$store.dispatch('helpdesk/updateDomain', { 
              id,
              [counter]: 0
            }).then(() => this.$store.dispatch("helpdesk/list")).then(() => {this.saving = false});
      },
      prepareRemove(type, i) {
        this.removeType = type;
        this.removeId = i.id;
        this.removeName = i.name;
        this.removeConfirm = true;
      },
      remove() {
        this.saving = true;
        this.$store.dispatch(`${this.removeType}/remove`, { 
              id: this.removeId
            }).then(() => this.$store.dispatch("helpdesk/list")).then(() => {this.saving = false; this.removeConfirm = false; this.removeName = null; this.removeId = null; this.removeType = null;});
     },

     async showHistory(item) {
      item.showHistory = true;
      item.history = await this.$store.dispatch('helpdesk/getBillingHistory', { id: item.cid });
     }
  },
  created() {
    this.$store.dispatch("helpdesk/list");
  },
};
</script>